import { api } from "./useApi";

export const cuponsApi = () => ({
    async getCupons() {
        return api.post("cupons/listar");
    },
});
